import { render, staticRenderFns } from "./wx-msg-preview.vue?vue&type=template&id=2c02008e&scoped=true"
import script from "./wx-msg-preview.vue?vue&type=script&lang=js"
export * from "./wx-msg-preview.vue?vue&type=script&lang=js"
import style0 from "./wx-msg-preview.vue?vue&type=style&index=0&id=2c02008e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02008e",
  null
  
)

export default component.exports